import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-coordonnees-bancaires',
  templateUrl: './coordonnees-bancaires.component.html',
  styleUrls: ['./coordonnees-bancaires.component.scss']
})
export class CoordonneesBancairesComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }
  configuration = this.configurationService.get();
  fileNamePattern: RegExp = new RegExp(this.configurationService.get().global.fileNamePattern);

  ngOnInit(): void {
  }

}
